import { Play, VideoCamera } from "@phosphor-icons/react";
import { Message } from "../../../models/Message";
import { formatDuration } from "../../../utils/time";
import { VideoView } from "./styles";
import { useState } from "react";
import { FileShowModal } from "../../Modals/FileShowModal";
import { User } from "../../../models/User";
import { Contact } from "../../../models/Contact";
import { useFileAccessURL } from "../../../hooks/useFileAccessURL";
import { getFileAccessReference } from "../../../utils/fileAccessURL";
import { MessageTextContent } from "../TextContent";

export interface VideoProps {
  message: Message;
    user: User;
    contact: Contact;
};

export const Video = ({
  message,
  contact,
  user,
}: VideoProps ) => {
  const [ open, setOpen ] = useState<boolean>( false );
  const thumbnailReference = getFileAccessReference(message.fileMetadata, "preview", "video");
  const thumbnailURL = useFileAccessURL({
    mode: "inline",
    reference: thumbnailReference,
  });

  return (
    <VideoView>
      <button
        type="button"
        className="thumbnail"
        aria-label={ `Reproduzir vídeo ${ message.fileMetadata?.fileName ?? "anexado" }` }
        onClick={() => setOpen( true )}
      >
        <img
          src={ thumbnailURL }
          alt={ message.fileMetadata?.fileName ?? "Prévia do vídeo anexado" }
        />

        <div className="play-view">
          <div>
            <Play
              size={ 24 }
              weight="fill"
            />
          </div>
        </div>

        <div className="info">
          <VideoCamera
            size={ 16 }
            weight="fill"
          />

          <span>{ formatDuration(( message.fileMetadata?.duration ?? 0 ) * 1000 )}</span>
        </div>
      </button>

      {
        message.content !== "" && (
          <MessageTextContent content={ message.content } />
        )
      }

      {
        open && (
          <FileShowModal
            message={ message }
            open={ open }
            onClose={() => setOpen( false )}
            user={ user }
            contact={ contact }
          />
        )
      }
    </VideoView>
  );
};
